import * as React from 'react'
import { useParams } from 'react-router-dom'

import { useTable, TableProvider } from '@/modules/drivers/context/TableContext'
import UsersTable from './components/UsersTable'
import UsersBasicActionBar from './components/UsersBasicActionBar'
import UsersSelectedActionBar from './components/UsersSelectedActionBar'

type Props = {
  /** Override `companyId` from the URL — useful when embedding the page outside its own route. */
  companyId?: string
}

const UsersListPageContent: React.FC<Props> = ({ companyId: companyIdProp }) => {
  const params = useParams<{ companyId: string }>()
  const companyId = companyIdProp ?? params.companyId!
  const { isSelectedAny, selectedGroup, resetAll } = useTable()

  return (
    <div className="tw-flex tw-flex-col tw-flex-1 tw-min-h-0">
      <div className="tw-relative tw-flex-shrink-0 tw-bg-content-primary">
        {isSelectedAny ? (
          <UsersSelectedActionBar
            companyId={companyId}
            selectedGroup={selectedGroup}
            resetAll={resetAll}
          />
        ) : (
          <UsersBasicActionBar companyId={companyId} />
        )}
      </div>
      <div className="tw-z-10 tw-flex tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-pb-[110px]">
        <div className="tw-flex-1 tw-overflow-y-auto">
          <UsersTable companyId={companyId} />
        </div>
      </div>
    </div>
  )
}

export const UsersListPage: React.FC<Props> = (props) => {
  return (
    <TableProvider>
      <UsersListPageContent {...props} />
    </TableProvider>
  )
}
